import { deepOrange, deepPurple, blue, indigo, teal, yellow, blueGrey, lightGreen, lime } from '@material-ui/core/colors';

const colors = [
  blue[500],
  deepOrange[500],
  deepPurple[500],
  lime[500],
  indigo[500],
  teal[500],
  yellow[500],
  blueGrey[500],
  lightGreen[500],
];

const getHashCode = str => {
  let hash = 0;
  if (str.length === 0) return hash;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return Math.abs(hash);
};

const generateColorFromName = name => {
  const index = getHashCode(name) % colors.length;
  return colors[index];
};

const generateInitials = (firstName, lastName) => firstName[0] + lastName[0];

export function generateColor(firstName, lastName) {
  return generateColorFromName(generateInitials(firstName, lastName));
}



// WEBPACK FOOTER //
// ./src/utils/avatarColorGenerator.js